module.exports = __webpack_public_path__ + "img/home-banner-6.16370423.png";